<template>
    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>

        <form v-if="showView">
            <row-component>
                <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.type}">
                    <label>Entrada/Saída:</label>
                    <Multiselect v-model="formData.type" :options="selectEntranceExitList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.attended}">
                    <label>Antecipado:</label>
                    <Multiselect v-model="formData.attended" :options="selectYesNoList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.bank_accounts_id}">
                    <label>Conta Bancária:</label>
                    <Multiselect label="name" v-model="formData.bank_accounts_id" :options="selectAccountBankList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.account_types_id}">
                    <label>Tipo de Conta:</label>
                    <Multiselect v-model="formData.account_types_id" :options="selectAccountList" :searchable="true"
                                 @select="loadAccountTypeSubMultiSelect(formData.account_types_id)"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.account_type_sub_id}">
                    <label>Tipo de Sub Conta:</label>
                    <Multiselect v-model="formData.account_type_sub_id" :options="selectAccountSubList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.amount}">
                    <label>Quantidade:</label>
                    <input-component :type-input="'number'" v-model="formData.amount"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.frequency}">
                    <label>Periodicidade:</label>
                    <Multiselect v-model="formData.frequency" :options="selectFrequencyList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.price}">
                    <label>Valor:</label>
                    <input-component v-money="money" :type-input="'text'" v-model="formData.price"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.due_date}">
                    <label>Data de Vencimento:</label>
                    <input-component v-mask="'##/##/####'" :type-input="'text'" v-model="formData.due_date"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.obs}">
                    <label>Observações:</label>
                    <input-text-area :rows="4" v-model="formData.obs"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <button-submit :disaabled="sendForm" @submit="submit" :items="buttonSubmit" style="width: 100%;"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <button-route :items="buttonRoute" style="width: 100%;"/>
                </row-col-component>
            </row-component>
        </form>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import InputTextArea from '@/components/form/InputTextArea';
import ErrorComponent from "@/components/alerts/ErrorComponent";
import {MONEY} from "@/configs/constants";
import {useToast} from "vue-toastification";
import {VMoney} from "v-money";
import {mask} from "vue-the-mask";

const toast = useToast()
export default {
    name: 'EntranceExitPreviewCreate',

    created() {
        this.$store.dispatch('updateNamePage', 'Entrada/Saída (Previsão)')
        this.$store.dispatch('loadAccountBankMultiSelect')
        this.$store.dispatch('loadAccountTypeMultiSelect')
        this.checkACL()
    },

    components: {
        ErrorComponent,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        InputTextArea
    },

    directives: {
        mask,
        money: VMoney
    },

    data() {
        return {
            itensOne: {
                title: "Adicionar",
                icon: "ti-pencil-plus"
            },

            buttonSubmit: {
                icon: 'ti-circle-plus',
                nameButton: 'Adicionar',
                typeButton: 'button'
            },

            buttonRoute: {
                icon: 'ti-arrow-back-up',
                route: '/entrance-exit-preview/search',
                name: 'Voltar'
            },

            formData: {
                type: '',
                bank_accounts_id: '',
                account_types_id: '',
                due_date: '',
                price: '',
                business: '',
                frequency: '',
                account_type_sub_id: '',
                amount: '',
                obs: '',
                account_type_sub: '',
                attended: ''
            },

            money: MONEY,

            errors: [],
            showView: false,
            sendForm: false,
            showError: false,
        }
    },

    methods: {

        loadAccountTypeSubMultiSelect(id) {
            this.$store.dispatch('loadAccountTypeSubMultiSelect', id)
        },

        submit() {
            if (!this.sendForm) {
                this.sendForm = true;
                this.$store.dispatch('storeEntranceExitPreview', this.formData)
                    .then(() => {
                        this.showError = false
                        this.sendForm = false
                        this.errors = []
                        toast.success("Cadastro efetuado com sucesso", {timeout: 2000});
                    }).catch((r) => {
                    this.showError = true;
                    this.sendForm = false
                    this.errors = r.response.data.errors;
                    this.scrollToTop()
                    toast.error("Seu formulário contém erros verificar!", {timeout: 2000});
                })
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 16)
                .then((r) => {
                    if (r.data.indexOf('entrance-exit-preview-create') !== -1) {
                        this.showView = true
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectFrequencyList() {
            return this.$store.state.var.selectFrequencyList
        },

        selectEntranceExitList() {
            return this.$store.state.var.selectEntranceExitList
        },

        selectYesNoList() {
            return this.$store.state.var.selectYesNoList
        },

        selectAccountBankList() {
            return this.$store.state.var.selectAccountBankList
        },

        selectAccountList() {
            return this.$store.state.var.selectAccountList
        },

        selectAccountSubList() {
            return this.$store.state.var.selectAccountSubList
        },
    }

}
</script>